import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Toronto',
    rating: 5,
    text: 'My fridge stopped cooling on a Sunday and they came within 2 hours! Fixed it on the spot. Amazing service.',
    date: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Michael T.',
    location: 'Vaughan',
    rating: 5,
    text: 'Professional, punctual, and honest. They diagnosed my dishwasher issue quickly and the price was fair. Highly recommend!',
    date: '1 month ago'
  },
  {
    id: 3,
    name: 'Jennifer L.',
    location: 'Richmond Hill',
    rating: 5,
    text: 'Best appliance repair service in the GTA. They fixed my Samsung washer when two other companies couldn\'t figure it out.',
    date: '3 weeks ago'
  },
  {
    id: 4,
    name: 'David K.',
    location: 'Markham',
    rating: 5,
    text: 'Fast response time and excellent communication. The technician explained everything clearly. Will use again!',
    date: '1 week ago'
  },
];

const StarRating = ({ rating }) => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={18}
        className={i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}
      />
    ))}
  </div>
);

export const Testimonials = () => {
  return (
    <section className="py-20 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 rounded-full bg-[#FF6B00]/10">
            <Star className="fill-yellow-400 text-yellow-400" size={20} />
            <span className="font-semibold" style={{ color: '#FF6B00' }}>4.9/5 on Google</span>
          </div>
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif', color: '#1A2B4C' }}
          >
            What Our Customers Say
          </h2>
          <p className="text-lg text-[#475569] max-w-2xl mx-auto">
            Don't just take our word for it. See why GTA homeowners trust us with their appliances.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id}
              className={`testimonial-card glass-card border-0 shadow-lg hover:shadow-xl fade-up-delay-${index % 4}`}
              data-testid={`testimonial-${testimonial.id}`}
            >
              <CardContent className="p-6">
                <Quote className="text-[#FF6B00]/20 mb-4" size={32} />
                <p className="text-[#475569] mb-4 leading-relaxed min-h-[100px]">
                  "{testimonial.text}"
                </p>
                <div className="pt-4 border-t border-gray-100">
                  <StarRating rating={testimonial.rating} />
                  <div className="mt-3 flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-[#1A2B4C]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-[#475569]">{testimonial.location}</p>
                    </div>
                    <span className="text-xs text-[#475569]">{testimonial.date}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Reviews Badge */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-gray-50 border border-gray-200">
            <img 
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
              alt="Google" 
              className="h-6"
            />
            <span className="text-[#475569]">|</span>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-semibold text-[#1A2B4C]">4.9</span>
            <span className="text-[#475569]">based on 150+ reviews</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
